import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/app/[lang]/(web)/prag/style.scss");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/ar.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/en.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/es.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/fr.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/hi.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/pt.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/ru.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/zh.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/prag/candy-crown.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/prag/mini-hero.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/prag/prag-logo.svg");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/prag/tornado-el.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/prag/tree-el.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/prag/tree-element.png");
